import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  const exhSelect = jQuery('select.js-select-header-project');

  exhSelect.on('select2:select', function (e) {
    let id = e.params.data.id;
    let name = 'exh-selected';

    if(id !== undefined && id !== null && id != ''){
      BX.setCookie(name, id, {path: '/'});

      const url = new URL(<any>window.location);
      let exhibition = url.searchParams.get('exhibition');
      if (exhibition) {
        url.searchParams.delete('exhibition');
        // @ts-ignore
        history.pushState(null, null, url);
      }
      window.location.reload();
    }
  });

  const url = new URL(<any>window.location);
  let id = url.searchParams.get('exhibition');
  let name = 'exh-selected';
  if(id !== undefined && id !== null && id != '') {
    BX.setCookie(name, id, {path: '/'});
  }

});
